import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AuthActions } from '../../actions'
import {FormControl, Grid, Button, Paper, Input, InputLabel, CircularProgress, colors, Typography, Icon} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import logo from './images/logo-symbol.png'

const styles = (theme) => ({
    grid: {
        width: '100%',
        height: '100vh'
    },
    paper: {
        width: '30%',
        padding: '3vw'
    },
    logoAvatar: {
        width: '30%',
        margin: '0 35% 1vw'
    },
    submit: {
        margin: '2vw 0 1vw',
        padding: '1vw'
    },
    typographyError: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },  
    fabProgress: {
        color: colors.green[500],
    }
});

class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            submit: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(e) {
        const updatedState = {...this.state};
        updatedState[e.target.name] = e.target.value;

        this.setState(updatedState);
    }

    handleSubmit() {
        const {dispatch} = this.props;
        const {email, password} = this.state;

        this.setState({submit: true});
        dispatch(AuthActions.login({email: email, password: password}));
    }

    componentDidMount() {
        const {dispatch, location} = this.props;
        dispatch(AuthActions.redirectFrom(location.state));
    }

    render () {
        const { classes, auth } = this.props;
        const {submit} = this.state;

        return (
            <React.Fragment>
                <Grid className={classes.grid}
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Paper className={classes.paper}>
                        <img src={logo} className={classes.logoAvatar} alt="SELPHO"/>
                        
                        <FormControl margin="normal" required fullWidth>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input 
                                id="email" 
                                name="email"  
                                autoComplete="email" 
                                autoFocus 
                                value={this.state.email}
                                onChange={this.handleInputChange}
                            />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                            <InputLabel htmlFor="password">Password</InputLabel>
                            <Input
                                name="password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={this.state.password}
                                onChange={this.handleInputChange}
                            />
                        </FormControl>
                        <Button
                            type="submit"
                            fullWidth
                            variant="raised"
                            color="primary"
                            className={classes.submit}
                            onClick={this.handleSubmit}
                            disabled={auth.process}
                        >
                            {!auth.process && `Sign in`}
                            {auth.process && submit && <CircularProgress size={20} className={classes.fabProgress} />}
                        </Button>
                        <Typography className={`${classes.typographyError} ${submit && auth.error ? '' : 'hide'}`} align="left" color="error" gutterBottom={false} >
                            <Icon>error_outline</Icon>&nbsp; Email or password is invalid
                        </Typography>
                    </Paper>
                </Grid>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer
    }
}

const LoginPageWithRedux = withStyles(styles)(connect(mapStateToProps)(LoginPage));

export {LoginPageWithRedux as LoginPage};


// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.jsx